import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Report from "./Report"
import Report2025 from "./Report2025"
import { CircularProgress, Backdrop } from "@mui/material"

const ReportRouter = ({ token }) => {
  const { sessionId } = useParams()
  const [namespace, setNamespace] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchNamespace = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/surveySession/${sessionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json"
            }
          }
        )

        if (!res.ok) {
          throw new Error(`Erreur ${res.status} — impossible de charger la session`)
        }

        const data = await res.json()
        console.log("Réponse API:", data)
        console.groupEnd()

        setNamespace(data.namespace || null)
      } catch (e) {
        console.error("[ReportRouter] Erreur récupération namespace:", e)
        setError(e)
      } finally {
        setLoading(false)
      }
    }

    fetchNamespace()
  }, [sessionId, token])

  if (loading) {
    return (
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  if (error) {
    return (
      <div
        style={{
          padding: "40px",
          color: "#c00",
          textAlign: "center",
          fontSize: "18px"
        }}
      >
        Erreur lors du chargement du rapport.<br />
        <small>{error.message}</small>
      </div>
    )
  }

  switch (namespace) {
    case "BaaS25E":
      console.log("[ReportRouter] Namespace BaaS25E → utilisation de Report2025.jsx")
      return <Report2025 token={token} />

    case "BaaS22E":
    case "BaaS20E":
      console.log("[ReportRouter] Namespace 2020/2022 → utilisation de Report.jsx")
      return <Report token={token} />

    default:
      console.warn(
        `[ReportRouter] Namespace inconnu (${namespace}) — fallback sur Report.jsx`
      )
      return <Report token={token} />
  }
}

export default ReportRouter